module.exports = __webpack_public_path__ + "static/sundance-83183ea3e098938cb7a2628af04a7128.jpg";